import {START_PLAY_VIDEO_EVENT, STOP_PLAY_VIDEO_EVENT} from "../constants/events";
import animejs from "animejs";

export const VIDEO_SHOWN_EVENT = 'videoShown';

export default class CoachCircle {
    constructor($root) {
        this.$root = $root;
        this.$video = this.$root.querySelector('.coach-circle-video');
        this.$videoPlayer = this.$root.querySelector('.coach-circle-video-player');
        this.$close = this.$root.querySelector('.coach-circle-video-close');

        this.init();
    }

    init() {
        this.addEventListeners();
    }

    addEventListeners() {
        this.$root.addEventListener('click', (e) => {
            if (e.target.closest('.coach-circle-video-close')) {
                return;
            }

            this.$root.dispatchEvent(new CustomEvent(VIDEO_SHOWN_EVENT, {
                detail: this
            }));
            this.show();
        });

        this.$close.addEventListener('click', () => {
            window.dispatchEvent(new CustomEvent(STOP_PLAY_VIDEO_EVENT));
        });

        window.addEventListener(STOP_PLAY_VIDEO_EVENT, () => {
            this.close();
        });
    }

    show() {
        if (this.$root.classList.contains('-video')) {
            return;
        }

        this.$root.classList.add('-video');
        window.dispatchEvent(new CustomEvent(START_PLAY_VIDEO_EVENT));
        animejs({
            targets: this.$video,
            opacity: [0, 1],
            scale: [0.5, 1],
            duration: 200,
            easing: 'easeInOutCubic',
            complete: (anim) => {
                if (anim.completed) {
                    this.$videoPlayer.play();
                }
            }
        });
    }

    close() {
        animejs({
            targets: this.$video,
            opacity: [1, 0],
            scale: 0.5,
            duration: 200,
            easing: 'easeInOutCubic',
            complete: (anim) => {
                if (anim.completed) {
                    this.$root.classList.remove('-video');
                    this.$videoPlayer.pause();
                    this.$videoPlayer.currentTime = 0;
                }
            }
        });
    }
}